/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import appTileAnalytics from './appTileAnalytics';
import BannerAnalytics from './bannerAnalytics';
import CatalogAnalytics from './catalogAnalytics';
import DialogAnalytics from './dialogAnalytics';
import PDPAnalytics from './pdpAnalytics';
import sideNavAnalytics from './sideNavAnalytics';
import InformationDialogAnalytics from './informationDialogAnalytics';
import CancelFeedbackDialogAnalytics from './cancelFeedbackDialogAnalytics';

const analyticsSharedData = {
    shouldSendLoadTime: true,
    appsRenderAnalyticsArray: [],
    wamConnected: false,
    shouldSendWamAppsRenderEvent: true,
};

export {
    appTileAnalytics,
    BannerAnalytics,
    CatalogAnalytics,
    DialogAnalytics,
    PDPAnalytics,
    sideNavAnalytics,
    InformationDialogAnalytics,
    analyticsSharedData,
    CancelFeedbackDialogAnalytics,
};
